(window as any).global = window;
(window as any).process = { env: { DEBUG: undefined } };
(window as any).module = { exports: {} };

import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component'; // Import your root component
import { environment } from '@env/environment';

import { Amplify } from 'aws-amplify';

import awsConfig from './aws-exports';

registerLocaleData(localeEsMx, 'es-MX');

if (environment.production) {
    enableProdMode();
}
Amplify.configure(awsConfig);
import { appConfig } from 'app/app.config';

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
